import {useQuery} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {queryKeys} from '../../../../queryKeys';
import {FetchPriceValidationCheck} from './fetch-price-validation.models';

interface Props {
  workflowId: number;
  fetchId: number;
  enabled: boolean;
}

export function useFetchQuery({workflowId, fetchId, enabled}: Props) {
  const {data, isPending} = useQuery({
    queryKey: queryKeys.fetch.priceValidation(workflowId, fetchId),
    queryFn: () => AxiosHttpClient.get<FetchPriceValidationCheck>(
      `${environment.apiv4uri}workflow/${workflowId}/fetch/${fetchId}`,
    ),
    enabled,
  });

  return {
    fetchWrapperIsPending: isPending,
    fetchWrapper: data,
  };
}
